"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DATE_FORMAT = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdApollo = require("cccisd-apollo");
var _rotateCcw = _interopRequireDefault(require("cccisd-icons/rotate-ccw3"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdReactRouter = require("cccisd-react-router");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _Transcript = _interopRequireDefault(require("./Transcript"));
var _style = _interopRequireDefault(require("./style.css"));
var _certificateQuery = _interopRequireDefault(require("./certificateQuery.graphql"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Boilerplate = window.cccisd.boilerplate;
var Cccisd = window.cccisd;
var Fortress = window.cccisd.fortress;
var DATE_FORMAT = 'MMMM D, YYYY';
exports.DATE_FORMAT = DATE_FORMAT;
var DATE_FORMAT_UTC = 'YYYY-MM-DD HH:mm:ss';
var Certificate = function Certificate(_ref) {
  var actingPawnHash = _ref.actingPawnHash,
    actingPawnId = _ref.actingPawnId,
    basePath = _ref.basePath,
    deploymentId = _ref.deploymentId,
    deploymentSettings = _ref.deploymentSettings,
    hide = _ref.hide,
    language = _ref.language,
    latestFinalTestData = _ref.latestFinalTestData,
    mediatorProps = _ref.mediatorProps,
    parentDeploymentId = _ref.parentDeploymentId,
    relatedDeploymentId = _ref.relatedDeploymentId,
    settings = _ref.settings;
  var defaultCertificateId = '–';
  var certData = (0, _get2["default"])(settings, "staticCertificateId.".concat(Fortress.user.acting.data_type));
  if (certData) {
    defaultCertificateId = (0, _get2["default"])(Cccisd, certData.path) || '–';
  }

  // to prevent breaking changes, if settings doesn't contain `certificates`
  // key, convert from old to new
  var certificates = settings.certificates || [{
    backgroundId: settings.backgroundId,
    courseName: settings.courseName,
    freeText: settings.freeText
  }];
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    backgroundUrls = _useState2[0],
    setBackgroundUrls = _useState2[1];
  var _useState3 = (0, _react.useState)(defaultCertificateId),
    _useState4 = _slicedToArray(_useState3, 2),
    certificateId = _useState4[0],
    setCertificateId = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formattedDate = _useState6[0],
    setFormattedDate = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    completedAt = _useState8[0],
    setCompletedAt = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState10 = _slicedToArray(_useState9, 2),
    name = _useState10[0],
    setName = _useState10[1];
  var _useState11 = (0, _react.useState)(true),
    _useState12 = _slicedToArray(_useState11, 2),
    loading = _useState12[0],
    setLoading = _useState12[1];
  var params = (0, _cccisdReactRouter.useParams)();
  var defaultName = 'Full Name Here';

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYLE-RELATED ///////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    function getBackgroundUrl(_x, _x2) {
      return _getBackgroundUrl.apply(this, arguments);
    }
    function _getBackgroundUrl() {
      _getBackgroundUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(bgId, returnObj) {
        var baseUrl, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                baseUrl = Boilerplate.route('api.resources.file.index');
                _context.next = 3;
                return _cccisdAxios["default"].get("".concat(baseUrl, "?id=").concat(bgId));
              case 3:
                response = _context.sent;
                if (response.status === 200 && response.data.status === 'success') {
                  returnObj[bgId] = response.data.data[0].published_url;
                }
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getBackgroundUrl.apply(this, arguments);
    }
    function getCertificateDateAndUser() {
      return _getCertificateDateAndUser.apply(this, arguments);
    }
    function _getCertificateDateAndUser() {
      _getCertificateDateAndUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var actingUser, altName, result, ap, user;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!actingPawnId || !language || !deploymentId)) {
                  _context2.next = 6;
                  break;
                }
                actingUser = Fortress.user.acting.user || {};
                altName = actingUser.full_name || actingUser.username || defaultName;
                setName(altName);
                setFormattedDate((0, _momentTimezone["default"])().format(DATE_FORMAT));
                return _context2.abrupt("return");
              case 6:
                _context2.next = 8;
                return _cccisdApollo.client.query({
                  query: _certificateQuery["default"],
                  fetchPolicy: 'network-only',
                  variables: {
                    deploymentId: deploymentId,
                    language: language,
                    actingPawnHash: actingPawnHash,
                    actingPawnId: actingPawnId
                  }
                });
              case 8:
                result = _context2.sent;
                ap = result.data.flows.assignmentProgress;
                if (ap.completedDate) {
                  setFormattedDate(_momentTimezone["default"].utc(ap.completedDate).format(DATE_FORMAT));
                  setCompletedAt(_momentTimezone["default"].utc(ap.completedAt).format(DATE_FORMAT_UTC));
                } else if (latestFinalTestData && latestFinalTestData.date) {
                  setFormattedDate(_momentTimezone["default"].utc(latestFinalTestData.date).format(DATE_FORMAT));
                  setCompletedAt(_momentTimezone["default"].utc(latestFinalTestData.date).format(DATE_FORMAT_UTC));
                } else {
                  setFormattedDate((0, _momentTimezone["default"])().format(DATE_FORMAT));
                  setCompletedAt((0, _momentTimezone["default"])().format(DATE_FORMAT_UTC));
                }
                user = ap.pawn.user;
                setName(user.fullName || user.username || defaultName);
                if (!certData) {
                  setCertificateId(ap.assignmentProgressId + 1000000);
                }
              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getCertificateDateAndUser.apply(this, arguments);
    }
    function loadData() {
      return _loadData.apply(this, arguments);
    }
    function _loadData() {
      _loadData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var loadingPromises, startingBackgroundIds, localBackgroundUrls, backgroundIdsPromised;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (hide) {
                  _context3.next = 9;
                  break;
                }
                loadingPromises = [];
                startingBackgroundIds = certificates.filter(function (c) {
                  return c.backgroundId;
                }).map(function (c) {
                  return c.backgroundId;
                });
                localBackgroundUrls = {};
                if (Object.keys(backgroundUrls).length === 0 && startingBackgroundIds.length > 0) {
                  backgroundIdsPromised = [];
                  startingBackgroundIds.forEach(function (bgId) {
                    if (!backgroundIdsPromised.includes(bgId)) {
                      backgroundIdsPromised.push(bgId);
                      loadingPromises.push(getBackgroundUrl(bgId, localBackgroundUrls));
                    }
                  });
                }
                loadingPromises.push(getCertificateDateAndUser());
                _context3.next = 8;
                return Promise.all(loadingPromises);
              case 8:
                setBackgroundUrls(localBackgroundUrls);
              case 9:
                setLoading(false);
              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _loadData.apply(this, arguments);
    }
    loadData();
  }, [hide]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL METHODS /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */
  function resetCourseProgress() {
    return _resetCourseProgress.apply(this, arguments);
  }
  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */
  function _resetCourseProgress() {
    _resetCourseProgress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var resp, subRelatedDeploymentId, options, deploymentIdsToReset, refreshLocation;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setLoading(true);
              _context4.next = 3;
              return _cccisdAxios["default"].get(Boilerplate.route('api.assignmentDeployment.repeated', {
                deploymentId: parentDeploymentId,
                pawnId: actingPawnId,
                hash: actingPawnHash
              }), {
                params: {
                  relatedDeploymentId: relatedDeploymentId,
                  isResetCourse: true,
                  isPawnHash: true
                }
              });
            case 3:
              resp = _context4.sent;
              subRelatedDeploymentId = (0, _get2["default"])(resp, 'data.data.deploymentId', '');
              if (!((0, _get2["default"])(resp, 'data.status', '') !== 'success' || !subRelatedDeploymentId)) {
                _context4.next = 8;
                break;
              }
              (0, _cccisdNotification["default"])({
                message: 'Error resetting progress.',
                type: 'danger',
                data: resp.data
              });
              return _context4.abrupt("return");
            case 8:
              if (!(0, _get2["default"])(mediatorProps, 'course.isCurriculum', false)) {
                _context4.next = 13;
                break;
              }
              options = (0, _get2["default"])(mediatorProps, 'course.curriculumOptions', []) || [];
              deploymentIdsToReset = options.map(function (opt) {
                return opt.deploymentId;
              });
              _context4.next = 13;
              return Promise.all(deploymentIdsToReset.map(function (depId) {
                return _cccisdAxios["default"].get(Boilerplate.route('api.assignmentDeployment.repeated', {
                  deploymentId: depId,
                  pawnId: actingPawnId,
                  hash: actingPawnHash
                }), {
                  params: {
                    isResetCourse: true,
                    isPawnHash: true,
                    relatedDeploymentId: subRelatedDeploymentId
                  }
                });
              }));
            case 13:
              refreshLocation = basePath;
              if (params.currentDeploymentId) {
                refreshLocation = refreshLocation.slice(0, refreshLocation.lastIndexOf(params.currentDeploymentId) - 1);
              }

              // do full page refresh so that all state gets reset with new deployment info
              window.location = refreshLocation;
            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _resetCourseProgress.apply(this, arguments);
  }
  function renderContent(_ref2) {
    var accreditations = _ref2.accreditations,
      certificate = _ref2.certificate,
      showAccreditation = _ref2.showAccreditation,
      _ref2$viewType = _ref2.viewType,
      viewType = _ref2$viewType === void 0 ? 'browser' : _ref2$viewType;
    var containerStyle = viewType === 'browser' ? _style["default"].certificateContainerBrowser : _style["default"].certificateContainerPrint;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: containerStyle
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].certificate,
      style: {
        backgroundImage: "url(".concat(backgroundUrls[certificate.backgroundId], ")")
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].passDate
    }, formattedDate), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].certificateContent
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].name
    }, name), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].courseName
    }, certificate.courseName), certificate.freeText && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: certificate.freeText
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].certificateId
    }, /*#__PURE__*/_react["default"].createElement("b", null, certData && certData.label ? certData.label : 'Certificate ID:'), " ", certificateId)), showAccreditation && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].accreditationContainer
    }, accreditations.map(function (aText, i) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: i,
        className: _style["default"].accreditation
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: aText
      }));
    }))));
  }
  function renderCompletionText() {
    return settings.completionText ? /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].completionText
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: settings.completionText
    })) : null;
  }
  function renderRenewCertificate() {
    // if this deployment is not the child of a parent, it's likely
    // that the parent deployment needs `isRepeatable` toggled ON in settings
    if (!settings.allowRenew || !parentDeploymentId || !completedAt) {
      return null;
    }

    // TO-DO: if repeatInterval of parent deployment is edited, all
    // child deployments should also get the updated repeatInterval. this line checks child
    var repeatInterval = (0, _get2["default"])(deploymentSettings, 'repeatInterval', false);
    if (repeatInterval && completedAt) {
      var repeatIntervalParts = repeatInterval.split(' ').filter(function (item) {
        return item;
      });
      if (repeatIntervalParts.length === 2) {
        var repeatIntervalNumber = repeatIntervalParts[0];
        var repeatIntervalUnits = repeatIntervalParts[1];
        var cutoff = (0, _momentTimezone["default"])().subtract(Number.parseInt(repeatIntervalNumber, 10), repeatIntervalUnits).format(DATE_FORMAT_UTC);
        if (cutoff < completedAt) {
          return null;
        }
      }
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].allowRenewCertificate
    }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-default",
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement(_rotateCcw["default"], {
        spaceRight: true
      }), "Renew Certificate"),
      render: function render(_ref3) {
        var closeModal = _ref3.closeModal;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: settings.renewConfirmation
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: 'text-right ' + _style["default"].renewButtons
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-default",
          onClick: closeModal
        }, "No"), /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-primary",
          onClick: function onClick() {
            resetCourseProgress();
            closeModal();
          }
        }, "Yes")));
      },
      title: "Renew Certificate"
    }), /*#__PURE__*/_react["default"].createElement(_Transcript["default"], {
      actingPawnHash: actingPawnHash,
      actingPawnId: actingPawnId,
      mediatorProps: mediatorProps,
      parentDeploymentId: parentDeploymentId,
      relatedDeploymentId: relatedDeploymentId
    }));
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  if (hide) {
    return /*#__PURE__*/_react["default"].createElement("div", null, "You must first complete all requirements before accessing the ", settings.tabName, ".");
  }
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  var downloadFilename = "Certificate_".concat(certificateId).replace(/[ -]/g, '_').replace(/[^A-Za-z0-9_]/g, '').replace(/_$/, '');
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderCompletionText(), renderRenewCertificate(), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, {
    downloadFilename: downloadFilename
  }, certificates.map(function (certificate, index) {
    var accreditations = [certificate.accreditation1, certificate.accreditation2, certificate.accreditation3].filter(function (a) {
      return a;
    });
    var showAccreditation = accreditations.length > 0;
    return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.BrowserOnly, null, renderContent({
      accreditations: accreditations,
      certificate: certificate,
      showAccreditation: showAccreditation,
      viewType: 'browser'
    })), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.PrintOnly, null, renderContent({
      accreditations: accreditations,
      certificate: certificate,
      showAccreditation: showAccreditation,
      viewType: 'print'
    })));
  })));
};
Certificate.propTypes = {
  actingPawnHash: _propTypes["default"].string,
  actingPawnId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  deploymentId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  hide: _propTypes["default"].bool,
  language: _propTypes["default"].string,
  latestFinalTestData: _propTypes["default"].object,
  settings: _propTypes["default"].object
};
var _default = Certificate;
exports["default"] = _default;